/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdTeacherData202,
  PutApiV1PersonIdTeacherData400,
  PutApiV1PersonIdTeacherData401,
  PutApiV1PersonIdTeacherData404,
  PutApiV1PersonIdTeacherData500,
  PutApiV1PersonIdTeacherDataMutationRequest,
  PutApiV1PersonIdTeacherDataMutationResponse,
  PutApiV1PersonIdTeacherDataPathParams,
} from "../../types/personTeacherController/PutApiV1PersonIdTeacherData.ts";
import { personTeacherDataViewModelSchema } from "../personTeacherDataViewModelSchema.ts";
import { updateTeacherDataViewModelSchema } from "../updateTeacherDataViewModelSchema.ts";

export const putApiV1PersonIdTeacherDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdTeacherDataPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1PersonIdTeacherData202Schema = z.lazy(
  () => personTeacherDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdTeacherData202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdTeacherData400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdTeacherData400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdTeacherData401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdTeacherData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdTeacherData404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdTeacherData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdTeacherData500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdTeacherData500>;

export const putApiV1PersonIdTeacherDataMutationRequestSchema = z.lazy(
  () => updateTeacherDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdTeacherDataMutationRequest>;

export const putApiV1PersonIdTeacherDataMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdTeacherData202Schema,
) as unknown as ToZod<PutApiV1PersonIdTeacherDataMutationResponse>;
